module.exports = __webpack_public_path__ + "static/media/image_84.ea363661.png";